<template>
  <div class="col-12">
    <custom-menu></custom-menu>
    <dialog-plan-change :value="value" @refresh="getAnalyticsData"></dialog-plan-change>
    <tabulator-card
      class="refer-table people-team-table"
      style="box-shadow:none;"
      id="userAnalyticsTable"
      :tableData="userDetails.data"
      :tableOptions="userDetails.options"
      :tableColumns="userDetails.columns"
      @tabulatorDetails="getTabulatorDetails"
    >
      <template slot="header">
        <div
          class="row mb-3 mt-3"
          style="justify-content: space-between; margin:auto;box-shadow:none;"
        >
          <div class="team-title mt-2">User Analytics</div>
          <div class="d-flex">
            <div style="margin-top:10px">
              <button class="newTask" style="margin-right:16px;" @click="download">
                <i class="fa fa-download" aria-hidden="true"></i>Download CSV
              </button>
            </div>
            <div style="margin-top:10px">
              <button
                class="newTask"
                style="margin-right:16px;"
                @click="showModal=true;"
              >Monthly Users</button>
            </div>
            <div class>
              <input type="text" class="form-control" v-model="searchQuery" placeholder="Search" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b>Free Users:</b>
            {{freeUsersCount}}
          </div>
          <div class="col-6">
            <b>Paid Users:</b>
            {{paidUsersCount}}
          </div>
          <!-- <div class="col-4">
            <b>New Users per Month:</b>
            {{newUsersCount}}
          </div>-->
        </div>
        <div class="row">
          <div class="col-2">
            <b>Total Users :</b>
            {{totalLength}}
          </div>
          <div class="col-2">
            <b>Confirmed Users :</b>
            {{confirmedCount.length}}
          </div>
          <div class="col-2">
            <b>Unconfirmed Users :</b>
            {{unconfirmedCount.length}}
          </div>
          <div class="col-2">
            <b>Pricing Clicks :</b>
            {{totalActivateProCount}}
          </div>
          <div class="col-2">
            <b>Portfolios :</b>
            {{totalPortfolioCount}}
          </div>
          <div class="col-2">
            <b>Prorata :</b>
            {{totalProrataCount}}
          </div>
        </div>
      </template>
    </tabulator-card>
    <el-dialog
      left
      title="Users Per Month"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="showModal"
      @close="showModal=false"
      style="margin: 0 auto;"
      width="300px"
      class
    >
      <div class="row">
        <div class="w-100" style="margin-left:40px">
          <table>
            <tr>
              <th>Month</th>
              <th>Users</th>
            </tr>
            <tr v-for="(item,index) in monthlyUsersData" :key="index">
              <td>{{item.month}}</td>
              <td>{{item.value}}</td>
            </tr>
          </table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../../../axios_api";
import { TabulatorCard } from "../../../components/index";
import moment from "moment";
import { Dialog } from "element-ui";
import { Select, Option } from "element-ui";
import CustomMenu from "../Components/CustomMenu.vue";
import DialogPlanChange from '../Dialogs/DialogPlanChange.vue';
export default {
  computed: {
    userDetails() {
      let data = JSON.parse(JSON.stringify(this.usersData));
      data.map((item) => {
        if (item.Attributes) {
          item.Attributes.forEach((attr) => {
            if (attr.Name == "given_name") {
              item.name = attr.Value;
            } else if (item.fiifiDetails) {
              item.name =
                item.fiifiDetails.firstName != item.fiifiDetails.lastName
                  ? `${item.fiifiDetails.firstName}  ${item.fiifiDetails.lastName}`
                  : item.fiifiDetails.firstName;
            } else item.name = item.Username;
            if (attr.Name == "email") {
              item.email = `${attr.Value}`;
            }
          });
          if (item.UserCreateDate) {
            item.UserCreateDate = moment(item.UserCreateDate).format(
              "MM/DD/YYYY"
            );
          } else {
            item.UserCreateDate = "-";
          }
          item.last_logged_in = "";
        }
        if (
          item.google ||
          item.facebook ||
          item.twitter ||
          item.linkedin ||
          item.cognito ||
          item.ltse
        ) {
          item.name =
            item.firstName != item.lastName
              ? `${item.firstName} ${item.lastName}`
              : item.firstName;
          item.activateProCount = item.activatePro ? item.activatePro : 0;
          item.last_logged_in = item.last_logged_in ? item.last_logged_in : "";
          if (item.linkedin) item.email = item.linkedin.email;
          else if (item.google) item.email = item.google.email;
          else if (item.twitter) item.email = item.twitter.email;
          else if (item.cognito) item.email = item.cognito.email;
          else if (item.ltse) item.email = item.ltse.email;
          if (item.created) {
            item.UserCreateDate = moment(item.created).format("MM/DD/YYYY");
          } else {
            item.UserCreateDate = "";
          }
          if (item.last_logged_in) {
            item.last_logged_in = moment(item.last_logged_in).format(
              "MM/DD/YYYY"
            );
          } else {
            item.last_logged_in = "";
          }
          item.UserStatus = "CONFIRMED";
        }
      });
      let testEmails = [
        "sonunaveenc.c45@gmail.com",
        "krishnavamshi@gytworkz.com",
        "sreenivasmajji@hotmail.com",
        "naveen@gytworkz.com",
        "gandhars@gmail.com",
        "ooha@gytworkz.com",
        "chandra@gytworkz.com",
        "chandra@gytworkz.com",
        "gandhar@gytworkz.com",
        "kashu@yopmail.com",
        "krishnavamshi@yopmail.com",
        "naveen10@yopmail.com",
        "ooha@gytworkz.com",
        "kooha@yopmail.com",
        "ooha.s9963@gmail.com",
        "ooha.s9963@gmail.com",
        "sonu32@yopmail.com",
        "chandrapriya.suresh@gmail.com",
        "moushith@yopmail.com",
        "test@yopmail.com",
        "testprod@yopmail.com",
        "tesprod@yopmail.com",
        "testspinner@yopmail.com",
        "vamshi.alishetty@gmail.com",
        "vk@yopmail.com",
        "durga.mummadi@outlook.com",
        "rajesh.mummadi9@gmail.com",
        "rajesh.mommadi@gmail.com",
        "vamshi.alishetty@gmail.com",
        "sonu@yopmail.com",
        "sonunaveenc.c45@gmail.com",
        "naveen8@yopmail.com",
        "naveen10@yopmail.com",
        "chandrakant@gytworkz.com",
        "ooha@gytworkz.com",
        "srihari.palivela0522@gmail.com",
      ];
      let validAccounts = [];
      data.map((item) => {
        let index;
        if (item.email)
          index = testEmails.findIndex((testItem) => item.email == testItem);
        if (index < 0) validAccounts.push(item);
      });
      this.totalLength = validAccounts.length;
      this.unconfirmedCount = validAccounts.filter(
        (item) => item.UserStatus == "UNCONFIRMED"
      );
      this.confirmedCount = validAccounts.filter(
        (item) => item.UserStatus != "UNCONFIRMED"
      );
      validAccounts.map((item) => {
        item.portfolioCount = 0;
        item.proRataCount = 0;
        if (item.activateProCount) {
          this.totalActivateProCount += item.activateProCount;
        }
        if (item.fiifiDetails && item.fiifiDetails._id) {
          let portfolioProrataItem = this.portfolioProrataData.find((items) => {
            if (item.fiifiDetails._id == items.account) {
              return items;
            }
            if (portfolioProrataItem) {
              item.portfolioCount = portfolioProrataItem.portfolioCount;
              item.proRataCount = portfolioProrataItem.prorata;
            }
          });
        } else {
          if (item._id) {
            let portfolioProrataItemObj = this.portfolioProrataData.find(
              (items) => {
                if (item._id == items.account) {
                  return items;
                }
              }
            );
            if (portfolioProrataItemObj) {
              item.portfolioCount = portfolioProrataItemObj.portfolioCount;
              item.proRataCount = portfolioProrataItemObj.prorata;
            }
          }
        }
        this.totalPortfolioCount += item.portfolioCount;
        this.totalProrataCount += item.proRataCount;
      });
      return {
        data: validAccounts,
        options: {
          layout: "fitColumns",
          tooltips: true,
          virtualDom: false,
          pagination: "local",
          initialSort: [{ column: "last_logged_in", dir: "desc" }],
          layoutColumnsOnNewData: true,
          paginationSize: 40,
          paginationSizeSelector: true,
          tooltipsHeader: true,
        },
        columns: this.tableColumns,
      };
    },
    tableColumns() {
      const self = this;

      let handleMenu = function(_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [
            {
              title: "Plan Change",
              handler: () => {
                let data = _cell.getData();
                self.currentData = data;
                self.value.isShow=true;
                self.value.data = data;
                // console.log(self.value);
              }
            }
          ];
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-h" style="color:#0000004D;"></i>
        `;
      };
      
      var seatsEditor = function(cell, onRendered, success, cancel){
          //cell - the cell component for the editable cell
          //onRendered - function to call when the editor has been rendered
          //success - function to call to pass the successfuly updated value to Tabulator
          //cancel - function to call to abort the edit and return to a normal cell

          //create and style input
          var cellValue = cell.getValue()
          let input = document.createElement("input");

          input.setAttribute("type", "number");

          input.style.padding = "4px";
          input.style.width = "100%";
          input.style.boxSizing = "border-box";

          input.value = cellValue;

          onRendered(function(){
              input.focus();
              input.style.height = "100%";
          });

          // function onChange(){
          //     if(input.value != cellValue){
          //     }else{
          //         cancel();
          //     }
          // }

          //submit new value on blur or change
          input.addEventListener("blur", async() => {
            let data = cell.getData();
            if(data.fiifiDetails && data.seats && input.value!== data.seats){
              api.patch(`/${cell.getData().fiifiDetails._id}/${input.value}/updateSeats`).then((res) => {
                  console.log("seats update success");
                }).catch(err => {
                  console.log("error while updating seats : ", err);
                });
                success(input.value);
            }
            cancel();
            });
          // input.addEventListener("change", onChange);

          //submit new value on enter
          // input.addEventListener("keydown", function(e){
          //     // if(e.keyCode == 13){
          //     //     onChange();
          //     // }

          //     // if(e.keyCode == 27){
          //     //     cancel();
          //     // }
          //     onChange();
          // });

          return input;
      };
      return [
        {
          title: "Name",
          field: "name",
          sorter: "string",
        },
        {
          title: "Email",
          field: "email",
          sorter: "string",
        },
        {
          title: "Status",
          field: "UserStatus",
          sorter: "string",
        },
        {
          title: "Last Logged In",
          field: "last_logged_in",
          sorter: "string",
        },
        {
          title: "Created On",
          field: "UserCreateDate",
          sorter: "string",
        },
        {
          title: "#portfolios",
          field: "portfolioCount",
          sorter: "number",
        },
        {
          title: "#prorataCompanies",
          field: "proRataCount",
          sorter: "number",
          // cellClick:function(e, cell){
          // console.log("data : ", cell.getData())
          // },
        },
        {
          title: "Pricing Clicks",
          field: "activateProCount",
          sorter: "number",
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            if (data.activatePro) {
              return data.activatePro;
            } else return 0;
          },
        },
        {
          title: "# Seats",
          sorter: "number",
          field: "seats",
          width: 100,
          editor: seatsEditor
        },
         {
          title: "",
          field: "",
          sorter: "string",
          width: 20,
          headerSort: false,
          resizable: false,
          formatter: function(_cell, formatterParams) {
              if (_cell.getData()) {
                return handleMenu(_cell, formatterParams, formatterParams);
              } else {
                return "";
              }
          }
        }
      ];
    },
  },
  components: {
    TabulatorCard,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [CustomMenu.name]: CustomMenu,
    [DialogPlanChange.name]: DialogPlanChange
  },
  data() {
    return {
      currentData: null,
      usersData: [],
      totalLength: 0,
      tabulator: "",
      searchQuery: "",
      confirmedCount: 0,
      unconfirmedCount: 0,
      totalActivateProCount: 0,
      portfolioProrataData: [],
      userDummy: [],
      totalPortfolioCount: 0,
      totalProrataCount: 0,
      freeUsersCount: 0,
      paidUsersCount: 0,
      newUsersCount: 0,
      monthlyUsersData: [],
      showModal: false,
      value: {
        isShow: false
      }
    };
  },
  watch: {
    searchQuery: _.debounce(function (newVal) {
      this.tabulator.clearFilter(true);
      const self = this;
      self.tabulator.setFilter([
        [
          { field: "name", type: "like", value: self.searchQuery },
          { field: "email", type: "like", value: self.searchQuery },
          { field: "UserStatus", type: "like", value: self.searchQuery },
        ],
      ]);
    }, 100),
  },
  mounted() {
    api
      .get("/portfolio-prorata")
      .then((data) => {
        this.portfolioProrataData = data.data.encrypt.success;
        this.fillData();
      })
      .catch((err) => {
        console.log(err);
      });
    api
      .get("/fiifi/users/analytics")
      .then((data) => {
        this.userDummy = data.data.encrypt.success;
        this.fillData();
      })
      .catch((err) => {
        console.log(err);
      });
    api
      .get("/free-paid-count")
      .then((data) => {
        this.freeUsersCount = data.data.encrypt.success.freeUsers;
        this.paidUsersCount = data.data.encrypt.success.paidUsers;
        this.newUsersCount = data.data.encrypt.success.newUsers;
      })
      .catch((err) => {
        console.log(err);
      });
    this.getMonthlyUsers();
  },
  methods: {
    async getAnalyticsData(data){
        // let data = await api.get("/fiifi/users/analytics");
        this.userDummy = data.data.encrypt.success;
        this.fillData();
    },
    getTabulatorDetails(list) {
      this.tabulator = list;
    },
    download() {
      let currentTime = new Date().toLocaleString().split(", ").join("_");
      let fileName = `users_${currentTime}`;
      this.tabulator.download("csv", `${fileName}.csv`);
    },
    fillData() {
      if (
        this.portfolioProrataData &&
        this.portfolioProrataData.length > 0 &&
        this.userDummy &&
        this.userDummy.length > 0
      ) {
        this.usersData = JSON.parse(JSON.stringify(this.userDummy));
      } else {
        return;
      }
    },
    getMonthlyUsers() {
      api
        .get("/countOfUsersPerMonthly")
        .then((data) => {
          if (data.data && data.data.encrypt && data.data.encrypt.success) {
            this.monthlyUsersData = data.data.encrypt.success;
          }
          if (this.monthlyUsersData.length == 0) {
            this.getMonthlyUsers();
          }
        })
        .catch((err) => {
          console.log(err);
          this.getMonthlyUsers();
        });
    },
  },
};
</script>
<style lang="scss">
#userAnalyticsTable{
  .tabulator-editing{
    width: 100px !important;
  }
}
</style>